import './Slider.scss'

interface ISliderProps {
  onChange?: (value: string) => void
  label: string
  labelPosition?: 'before' | 'after'
  checked: boolean
}

export const Slider = (props: ISliderProps) => {
  return (
    <div className={`slider-checkbox ${props.labelPosition === 'before' ? 'label-before' : ''}`}>
      <div className="slider-checkbox-switch">
        <input type="checkbox" defaultChecked={props.checked} onChange={(e) => props.onChange ? props.onChange(e.currentTarget.checked.toString()) : undefined}/>
        <span className="slider round" />
      </div>
      <label>
          {props.label}
      </label>
    </div>
)
}